module.exports = __webpack_public_path__ + "static/flags/AF-870c02f0e1d7141636988d82b705d058.gif";